import { Check } from "lucide-react";

export const cardBase =
    "rounded-2xl border border-black/10 bg-white/70 backdrop-blur-sm transition-all duration-300 group-hover:border-neon group-hover:shadow-[0_0_0_1px_#14b8a6,0_24px_60px_-22px_rgba(20,184,166,0.45)]";

const MockRow = ({ label }) => (
    <div className="flex items-center gap-3 rounded-xl border border-black/[0.07] bg-black/[0.02] px-3.5 py-2.5 transition-colors group-hover:border-neon/30">
        <span className="shrink-0 w-5 h-5 rounded-full bg-neon/15 text-neon flex items-center justify-center">
            <Check size={13} strokeWidth={3} />
        </span>
        <span className="font-body text-sm text-black/75 truncate">
            {label}
        </span>
        <span className="ml-auto font-mono text-[10px] text-black/40">AUTO</span>
    </div>
);

export const MockPanel = ({ pillar, className = "", fullTitle = false }) => {
    const Icon = pillar.icon;
    const title = fullTitle ? pillar.tag : pillar.card || pillar.tag;
    return (
        <div className={`${cardBase} p-7 sm:p-8 h-full flex flex-col ${className}`}>
            <div className="flex items-center justify-between">
                <span className="font-mono text-xs tracking-[-0.01em] text-black/50">
                    FRANKEL · AGENT
                </span>
                <span className="inline-flex items-center gap-1.5 font-mono text-[11px] text-neon">
                    <span className="w-1.5 h-1.5 rounded-full bg-neon animate-pulse" />
                    LIVE
                </span>
            </div>

            <div className="mt-6 flex items-center gap-4">
                <span className="w-14 h-14 rounded-2xl bg-black flex items-center justify-center text-white group-hover:bg-neon group-hover:text-black transition-colors duration-300">
                    <Icon size={26} strokeWidth={1.75} />
                </span>
                <div>
                    <div className="font-mono text-sm tracking-[-0.01em] text-black">
                        {title}
                    </div>
                    <div className="font-body text-xs text-black/50">
                        Autonomous module
                    </div>
                </div>
            </div>

            <div className="mt-6 space-y-2.5 flex-1">
                {pillar.bullets.map((b) => (
                    <MockRow key={b.lead} label={b.lead.replace(/:$/, "")} />
                ))}
            </div>

            <div className="mt-6 h-1.5 w-full rounded-full bg-black/5 overflow-hidden">
                <div className="h-full w-2/3 rounded-full bg-gradient-to-r from-neon/40 to-neon" />
            </div>
        </div>
    );
};
